import request from '@/axios/personalCenter'

// R06-获取施工交付方案详情
export function getFiveDetails(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getFiveDetails',
    method: 'post',
    data
  })
}

// R07-获取增值服务方案详情
export function getSixDetails(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/final_plan_step/getSixDetails',
    method: 'post',
    data
  })
}

// R09-获取报价详情
export function getBasics(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/offer/getBasics',
    method: 'post',
    data
  })
}
// R10-获取报价金额汇总
export function getAmountSummary(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/offer/getAmountSummary',
    method: 'post',
    data
  })
}
